import React, { useEffect, useState } from "react";
import { FormControl, FormLabel, Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "../../../../utils/axios";
import "../../../../assets/css/react-select.css";
import CustomDropdown from "../../../utilities/CustomDropdown";

const AddDevice = (props) => {
  const [deviceId, setDeviceId] = useState("");
  const [deviceName, setDeviceName] = useState("");
  const [deviceType, setDeviceType] = useState("");
  const [flowrateUnit, setFlowrateUnit] = useState("");
  const [totalizerUnit, setTotalizerUnit] = useState("");
  const [levelDepthUnit, setLevelDepthUnit] = useState("");

  const [deviceIMEI, setDeviceIMEI] = useState("");
  const [simNumber, setSimNumber] = useState("");
  const [id, setId] = useState("");
  const [dealerList, setDealerList] = useState([]);
  const [dealer, setDealer] = useState("");
  const [depth, setDepth] = useState(0);
  const [customerList, setCustomerList] = useState([]);
  const [customer, setCustomer] = useState("");
  const [installationDate, setInstallationDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  const [activationDate, setActivationDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  const [subscriptionEndDate, setSubscriptionEndDate] = useState(() => {
    const oneYearFromNow = new Date();
    oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
    return oneYearFromNow.toISOString().split("T")[0];
  });
  const [subscriptionCost, setSubscriptionCost] = useState(""); // Add this line

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (deviceId.includes(" ")) {
        Swal.fire({
          title: "Warning",
          text: "Do not add spaces in Device ID",
          icon: "warning",
        });
      } else {
        if (
          deviceId === "" ||
          deviceName === "" ||
          deviceType === "" ||
          deviceIMEI === "" ||
          installationDate === "" ||
          activationDate === ""
        ) {
          Swal.fire({
            title: "Warning",
            text: "Make sure that Device Id, Device Name, IMEI Number, Device type, Installation Date, Activation Date and Subscription End Date are not empty.",
            icon: "warning",
          });
        } else {
          const payload = {
            deviceId,
            device_type: deviceType,
            alias_name: deviceName,
            imei: `${deviceIMEI}`,
            sim_number: simNumber,
            depth: depth === "" ? null : depth,
            installation_date: installationDate,
            activation_date: activationDate,
            subscription_end_date: subscriptionEndDate,
            subscription_cost: subscriptionCost,
          };

          // Conditionally add extra fields based on type
          if (deviceType === "flow") {
            payload.flowrateUnit = flowrateUnit;
            payload.totalizerUnit = totalizerUnit;
          } else if (deviceType === "level" || deviceType === "level_transmitter") {
            payload.levelDepthUnit = levelDepthUnit;
            payload.level_unit = deviceType === "level_transmitter" ? (levelDepthUnit || "m") : levelDepthUnit;
          }

          await axios
            .post("add/device", payload)
            .then((res) => {
              setId(res.data.device.id);
              props.onHide();

              if (customer.length !== 0 && dealer.length === 0) {
                try {
                  axios
                    .post("assign/customer", {
                      deviceId: res.data.device.id,
                      customerId: customer,
                    })
                    .then(() => {
                      Swal.fire({
                        title: "Success",
                        text: "Device is successfully added",
                        icon: "success",
                      });
                    });
                } catch (error) {
                  Swal.fire({
                    title: "Try again",
                    text: "Try again",
                    icon: "error",
                  });
                }
              } else if (dealer.length !== 0 && customer.length === 0) {
                try {
                  axios
                    .post("assign/dealer", {
                      deviceId: res.data.device.id,
                      dealerId: dealer,
                    })
                    .then((res) => {
                      Swal.fire({
                        title: "Success",
                        text: "Device is successfully added",
                        icon: "success",
                      });

                      setDealer("");
                    });
                } catch (error) {
                  Swal.fire({
                    title: "Try Again",
                    text: "Try again",
                    icon: "error",
                  });
                }
              } else if (customer.length !== 0 && dealer.length !== 0) {
                try {
                  axios
                    .post("assign/customer", {
                      deviceId: res.data.device.id,
                      customerId: customer,
                    })
                    .then((res) => {
                      Swal.fire({
                        title: "Success",
                        text: "Device is successfully added",
                        icon: "success",
                      });
                      setCustomer("");
                    });

                  axios
                    .post("assign/dealer", {
                      deviceId: res.data.device.id,
                      dealerId: dealer,
                    })
                    .then((res) => {
                      Swal.fire({
                        title: "Assigned",
                        text: "Device is successfully added",
                        icon: "success",
                      });
                      setDealer("");
                    });
                } catch (error) {
                  Swal.fire({
                    title: "Try Again",
                    text: "Try again",
                    icon: "error",
                  });
                }
              } else {
                Swal.fire({
                  title: "Success",
                  text: `Device is successfully added`,
                  icon: "success",
                  confirmButtonText: "OK",
                });
              }
              setDeviceId("");
              setDeviceName("");
              setDeviceIMEI("");
              setSimNumber("");
              setDepth(0);
              setFlowrateUnit("");
              setTotalizerUnit("");
              setLevelDepthUnit("");
              setSubscriptionCost("");
            })
            .catch((e) => {
              Swal.fire({
                title: "Error",
                text: e.response.data.message,
                icon: "error",
                confirmButtonText: "OK",
              });
            });
        }
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Try again",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleReset = (e) => {
    e.preventDefault();

    setDeviceId("");
    setDeviceName("");
    setDeviceIMEI("");
    setSimNumber("");
    setDepth(0);
    setFlowrateUnit("");
    setTotalizerUnit("");
    setLevelDepthUnit("");
    setSubscriptionCost("");
  };

  useEffect(() => {
    // Set default units when device type changes
    if (deviceType === "flow") {
      setFlowrateUnit("m³/h");
      setTotalizerUnit("m³");
    } else if (deviceType === "level" || deviceType === "level_transmitter") {
      setLevelDepthUnit("m");
    }
  }, [deviceType]);

  useEffect(() => {
    (async () => {
      try {
        const getCustomerList = await axios.post("view/customers/list");
        setCustomerList(getCustomerList?.data);
      } catch (error) {
        setCustomerList([]);
      }

      try {
        const getDealerList = await axios.post("view/dealers/list");
        setDealerList(getDealerList?.data);
      } catch (error) {
        setDealerList([]);
      }
    })();
  }, []);

  return (
    <Modal
      {...props}
      dialogClassName="modal-75w"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <button className="close-icon" onClick={props.onHide}>
        <svg
          width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.4039 15.7032L30.3126 3.81334C30.6685 3.4574 30.8685 2.97463 30.8685 2.47125C30.8685 1.96787 30.6685 1.4851 30.3126 1.12916C29.9567 0.77321 29.4739 0.573242 28.9705 0.573242C28.4671 0.573242 27.9844 0.77321 27.6284 1.12916L15.7386 13.0379L3.84879 1.12916C3.49285 0.77321 3.01008 0.573243 2.5067 0.573243C2.00332 0.573243 1.52055 0.77321 1.16461 1.12916C0.808663 1.4851 0.608695 1.96787 0.608695 2.47125C0.608695 2.97463 0.808663 3.4574 1.16461 3.81334L13.0733 15.7032L1.16461 27.593C0.987436 27.7687 0.846811 27.9778 0.750844 28.2081C0.654878 28.4385 0.605469 28.6855 0.605469 28.9351C0.605469 29.1846 0.654878 29.4317 0.750844 29.662C0.846811 29.8924 0.987436 30.1014 1.16461 30.2772C1.34033 30.4543 1.5494 30.595 1.77975 30.6909C2.01009 30.7869 2.25716 30.8363 2.5067 30.8363C2.75624 30.8363 3.00331 30.7869 3.23366 30.6909C3.464 30.595 3.67307 30.4543 3.84879 30.2772L15.7386 18.3684L27.6284 30.2772C27.8041 30.4543 28.0132 30.595 28.2435 30.6909C28.4739 30.7869 28.721 30.8363 28.9705 30.8363C29.22 30.8363 29.4671 30.7869 29.6975 30.6909C29.9278 30.595 30.1369 30.4543 30.3126 30.2772C30.4898 30.1014 30.6304 29.8924 30.7264 29.662C30.8223 29.4317 30.8717 29.1846 30.8717 28.9351C30.8717 28.6855 30.8223 28.4385 30.7264 28.2081C30.6304 27.9778 30.4898 27.7687 30.3126 27.593L18.4039 15.7032Z"
            fill="black"
          />
        </svg>
      </button>
      <Modal.Body>
        <h4 className="modal-title">Add Device</h4>
        <form action="" className="modal-form">
          <div className="form-fields">
            <div>
              <FormLabel>
                Device Id<span className="text-danger">*</span>
              </FormLabel>
              <FormControl
                required
                value={deviceId}
                onChange={(e) => setDeviceId(e.target.value)}
                placeholder="Enter Device Id....."
              />
            </div>

            <div>
              <FormLabel>
                Device Name<span className="text-danger">*</span>
              </FormLabel>
              <FormControl
                required
                value={deviceName}
                onChange={(e) => setDeviceName(e.target.value)}
                placeholder="Enter Device Name....."
              />
            </div>

            <CustomDropdown
              label="Device Type"
              required
              items={[
                { id: "flow", name: "Flow Device" },
                { id: "level", name: "Level Device" },
                { id: "level_transmitter", name: "Level Transmitter" },
                { id: "gas", name: "Gas Device" },
                { id: "do_sensor", name: "DO Sensor" },
              ]}
              value={deviceType}
              onSelect={setDeviceType}
              searchPlaceholder="Search device types..."
            />
            {/* Conditionally render the unit fields */}
            {deviceType === "flow" && (
              <>
                <div>
                  <FormLabel>Flowrate Unit</FormLabel>
                  <FormControl
                    type="text"
                    value={flowrateUnit}
                    onChange={(e) => setFlowrateUnit(e.target.value)}
                    placeholder="e.g., m³/hr"
                  />
                </div>
                <div>
                  <FormLabel>Totalizer Unit</FormLabel>
                  <FormControl
                    type="text"
                    value={totalizerUnit}
                    onChange={(e) => setTotalizerUnit(e.target.value)}
                    placeholder="e.g., m³"
                  />
                </div>
              </>
            )}

            {deviceType === "level" && (
              <div>
                <FormLabel>Level Depth Unit</FormLabel>
                <FormControl
                  type="text"
                  value={levelDepthUnit}
                  onChange={(e) => setLevelDepthUnit(e.target.value)}
                  placeholder="e.g., meters"
                />
              </div>
            )}

            {deviceType === "level_transmitter" && (
              <div>
                <FormLabel>Level Unit</FormLabel>
                <FormControl as="select" value={levelDepthUnit || "m"} onChange={(e) => setLevelDepthUnit(e.target.value)}>
                  <option value="m">Meter (m)</option>
                  <option value="ft">Foot (ft)</option>
                  <option value="cm">Centimeter (cm)</option>
                </FormControl>
              </div>
            )}

            <div>
              <CustomDropdown
                label="Customer"
                items={customerList.map((item) => ({
                  id: item.customerId,
                  name: item.name,
                  email: item.email_id,
                }))}
                value={customer}
                onSelect={setCustomer}
                searchPlaceholder="Search customers..."
                showId={true}
              />
            </div>

            <div>
              <CustomDropdown
                label="Dealer"
                items={dealerList.map((item) => ({
                  id: item.dealerId,
                  name: item.name,
                }))}
                value={dealer}
                onSelect={setDealer}
                searchPlaceholder="Search dealers..."
                showId={false}
              />
            </div>

            <div>
              <FormLabel>
                IMEI Number<span className="text-danger">*</span>
              </FormLabel>
              <FormControl
                required
                type="number"
                value={deviceIMEI}
                onChange={(e) => setDeviceIMEI(e.target.value)}
                placeholder="Enter IMEI number....."
              />
            </div>

            <div>
              <FormLabel>Sim Number</FormLabel>
              <FormControl
                type="number"
                value={simNumber}
                onChange={(e) => setSimNumber(e.target.value)}
                placeholder="Enter SIM number....."
              />
            </div>

            <div>
              <FormLabel>Depth of device</FormLabel>
              <FormControl
                type="number"
                value={depth}
                onChange={(e) => setDepth(e.target.value)}
                placeholder="Enter depth of device....."
              />
            </div>

            <div>
              <FormLabel>
                Installation Date<span className="text-danger">*</span>
              </FormLabel>
              <FormControl
                required
                type="date"
                value={installationDate}
                onChange={(e) => setInstallationDate(e.target.value)}
              />
            </div>

            <div>
              <FormLabel>
                Activation Date<span className="text-danger">*</span>
              </FormLabel>
              <FormControl
                required
                type="date"
                value={activationDate}
                onChange={(e) => setActivationDate(e.target.value)}
              />
            </div>

            <div>
              <FormLabel>
                Subscription End Date<span className="text-danger">*</span>
              </FormLabel>
              <FormControl
                required
                type="date"
                value={subscriptionEndDate}
                onChange={(e) => setSubscriptionEndDate(e.target.value)}
              />
            </div>

            <div>
              <FormLabel>Subscription Cost</FormLabel>
              <FormControl
                type="number"
                value={subscriptionCost}
                onChange={(e) => setSubscriptionCost(e.target.value)}
                placeholder="Enter subscription cost..."
              />
            </div>

            {/* Map input here*/}
          </div>

          <div className="form-btn d-flex align-items-center mt-5">
            <button onClick={handleSubmit} type="submit" className="white-btn">
              Save
            </button>
            <button onClick={handleReset} className="white-btn ms-4">
              Reset
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddDevice;
